export const OFFER_STATUS = {
  DRAFT: 0,
  SENT: 1,
  ACCEPTED: 2,
  CONVERTED: 3,
  REJECTED: 4,
};

export const OFFER_STATUS_LABELS = {
  0: 'Draft',
  1: 'Sent',
  2: 'Accepted',
  3: 'Converted',
  4: 'Rejected',
};

// Normalize: backend may return string ("Draft") or integer (0)
const STATUS_STRING_TO_INT = {
  Draft: 0, Sent: 1, Accepted: 2, Converted: 3, Rejected: 4,
};

export const normalizeStatus = (status) => {
  if (typeof status === 'number') return status;
  return STATUS_STRING_TO_INT[status] ?? 0;
};

export const getStatusColor = (status) => {
  const colors = {
    0: '#9e9e9e',
    1: '#2196f3',
    2: '#4caf50',
    3: '#673ab7',
    4: '#f44336',
  };
  return colors[normalizeStatus(status)] || '#ffc107';
};

export const getStatusLabel = (status) => {
  return OFFER_STATUS_LABELS[normalizeStatus(status)] || 'Unknown';
};

export const canEditOffer = (status) => {
  const s = normalizeStatus(status);
  return s === OFFER_STATUS.DRAFT || s === OFFER_STATUS.SENT;
};

export const canDeleteOffer = (status) => {
  return normalizeStatus(status) !== OFFER_STATUS.CONVERTED;
};

export const canConvertOffer = (status) => {
  return normalizeStatus(status) === OFFER_STATUS.ACCEPTED;
};

export const canChangeStatus = (status) => {
  return normalizeStatus(status) !== OFFER_STATUS.CONVERTED;
};